export const LANGUAGES = [
  {
    code: "en",
  },
  {
    code: "ca",
  },
  {
    code: "zk",
  },
  {
    code: "hi",
  },
  {
    code: "es",
  },
  {
    code: "fr",
  },
  {
    code: "ar",
  },
  {
    code: "ru",
  },
  {
    code: "pt",
  },
  {
    code: "id",
  },
  {
    code: "de",
  },
  {
    code: "ja",
  },
  {
    code: "tr",
  },
  {
    code: "ko",
  },
  {
    code: "it",
  },
];
